import { toast } from "react-toastify";

export function validateForm(
  username,
  email,
  password,
  confirmPassword,
  gender,
  taxId,
  position,
  phoneNumber,
  userTypeId,
  theme,
) {
  const errors = {};

  if (!username) {
    errors.username = "Full name is required";

    toast.error(`${errors.username}`);
    return
  } else if (username.length > 100) {
    toast.error("The maximum length limit has been exceeded.");
    return
  }

  if (!email) {
    errors.email = "Email address is required";

    toast.error(`${errors.email}`);
    return
  } else if (email && !/\S+@\S+\.\S+/.test(email)) {
    errors.email = "Enter a valid email address";

    toast.error(`${errors.email}`);
    return
  }

  if (!password) {
    errors.password = "Password is required";
    toast.error(`${errors.password}`);
    return
  }
  //   else if (!/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}/.test(password)) {
  //       errors.password = 'The password must contain at least one uppercase letter,one lowercase letter, one number and one special character, and must be at least 8 characters long.';
  else if (password.length < 7) {
    errors.password = "The password must be at least 7 characters long.";
    toast.error(`${errors.password}`);
    return
  }

  if (password !== confirmPassword) {
    errors.confirmPassword = "The password does not match the confirmPassword.";

    toast.error(`${errors.confirmPassword}`);
    return

  }

  if (gender === "") {
    errors.gender = "Choose your gender";

    toast.error(`${errors.gender}`);
  }

  if (position === "") {
    errors.position = "Position is required";

    toast.error(`${errors.position}`);
  }

  if (phoneNumber === "") {
    errors.phoneNumber = "Phone number is required";

    toast.error(`${errors.phoneNumber}`);
  }

  // if (approvalStatus === '') {
  //     errors.approvalStatus = 'Approval Statusu is required';

  //     toast.error(`${errors.approvalStatus}`);
  // }

  if (userTypeId === 100) {
    errors.userTypeId = "Enter the User Type";

    toast.error(`${errors.userTypeId}`);
  }

  // if (theme === '') {
  //     errors.theme = 'Enter the Theme';

  //     toast.error(`${errors.theme}`);
  // }

  return errors;
}

export function validateFormPass(password, confirmPassword) {
  const errors = {}

  if (!password) {
    errors.password = 'Password is required'
  } else if (password.length < 7) {
    errors.password = 'The password must be at least 7 characters long.'
  }

  if (password !== confirmPassword) {
    errors.confirmPassword = 'The password does not match the confirm password.'
  }
  

  return errors
}

export function validateVerifyCode(verifyCode) {
  const errors = {}

  if (verifyCode.length < 7) {
    errors.verifyCode = 'The verify code must be 6 characters long.'
  }

  return errors
}